import axios from "axios";
import { errorHandler } from "@/Services/errorHandler";
import queryStringify from "qs-stringify";

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getFinanceData: async (context, data) => {
      let route = data.route;
      let query = data.query;
      let payload = {
        ...query,
        ...context.getters.getTimeFrame,
      };
      let stores = JSON.parse(localStorage.getItem(`stores`));
      let store = JSON.parse(localStorage.getItem(`selected_store`));

      if (stores.length === 0) return;
      let group = stores[0].Group;
      let storeDB = store.StoreDB;

      let headers = {
        group: window.btoa(group),
        DB: storeDB !== null ? window.btoa(storeDB) : null,
      };

      const queryString = `?` + queryStringify(payload);
      return axios
        .get(reportsApi + `${route}` + queryString, {
          headers,
        })
        .then(({ data }) => data)
        .catch((err) => errorHandler.tomcatError(err));
    },
  },
};
